export default __webpack_public_path__ + "static/media/agoda_homes_marketing_image.dfd01146.jpg";